import { attendenace } from "./attendance_reducer";
import { skillMatrix } from "./skill_matrix_reducer";
import { UserGroupMatrix } from "./user_skill_group_reducer";
import { skillSetMatrix } from "./skill_mapping_reducer";
import {login_Permission} from "./login_reducer"
import { Permission } from "./permission_reducers";
import {report_user} from "./report_reducer"
import { SubSkillReducers } from './subSkillReducer'
import { departmentReducers } from "./departmentReducer";
import { NewJoinerReducer } from "./newJoinerReducer";
import { combineReducers } from "redux";
export default combineReducers({
  attendenace,
  skillMatrix,
  UserGroupMatrix,
  skillSetMatrix,
  login_Permission,
  SubSkillReducers,
  departmentReducers,
  NewJoinerReducer,
  Permission, 
  report_user,
  
});
